import { createSlice } from '@reduxjs/toolkit';

export const plansSlice = createSlice({
  name: 'plans',
  initialState: {
    showCheckout: false,
    flowType: 'default',
    landing: '',
    plan: '',
    upsellPlan: '',
    planDetails: null,
    couponDetails: null,
  },
  reducers: {
    setShowCheckout: (state, action) => {
      state.showCheckout = action.payload;
    },
    setFlowType: (state, action) => {
      if (action.payload) {
        state.flowType = action.payload;
      }
    },
    setLanding: (state, action) => {
      if (action.payload) {
        state.landing = action.payload;
      }
    },
    setPlan: (state, action) => {
      state.plan = action.payload;
    },
    setUpsellPlan: (state, action) => {
      state.upsellPlan = action.payload;
    },
    setPlanDetails: (state, action) => {
      state.planDetails = action.payload;
    },
    setCouponDetails: (state, action) => {
      state.couponDetails = action.payload;
    },
  },
});

export const {
  setPlan,
  setUpsellPlan,
  setFlowType,
  setLanding,
  setPlanDetails,
  setShowCheckout,
  setCouponDetails,
} = plansSlice.actions;

export const selectShowCheckout = (state: any) => state.plans.showCheckout;
export const selectPlan = (state: any) => state.plans.plan;
export const selectUpsellPlan = (state: any) => state.plans.upsellPlan;
export const selectFlowType = (state: any) => state.plans.flowType;
export const selectLanding = (state: any) => state.plans.landing;
export const selectPlanDetails = (state: any) => state.plans.planDetails;
export const selectPlanCoupon = (state: any) => state.plans.couponDetails;

export default plansSlice.reducer;
